import { useTranslation } from 'react-i18next';
import { Modal, FeaturedIcon } from '@unified-checkout/design-system';
import { CircleExclamation } from '@unified-checkout/design-system/icons/index';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';
import { MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';

export interface EditHandleConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const EditHandleConfirmModal = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}: EditHandleConfirmModalProps) => {
  const { t } = useTranslation();
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  const title = t('innerLayout.paymePage.editHandleConfirm.title');

  const confirmButtonText = isMobile
    ? t('innerLayout.paymePage.editHandleConfirm.confirmButtonMobile')
    : t('innerLayout.paymePage.editHandleConfirm.confirmButton');

  return (
    <Modal
      open={open}
      onCloseHandler={onClose}
      hasCloseIcon={true}
      width="32rem"
      state="default"
      headerIcon={
        <FeaturedIcon icon={CircleExclamation} size="xl" color="yellow" />
      }
      keepHeaderIconDefaultColors={true}
      isOverlayAboveModal={true}
      title={title}
      btnsProps={[
        {
          text: confirmButtonText,
          variant: 'contained',
          color: 'primary',
          onClickHandler: onConfirm,
          disabled: isLoading,
          loading: isLoading,
        },
        {
          text: t('form.cancel'),
          variant: 'outlined',
          color: 'secondary',
          onClickHandler: onClose,
          disabled: isLoading,
        },
      ]}
    />
  );
};

